<template>
  <div class='main-container'>
    <div class="box-card">
      <div class="area-title">
        <span>电子签章服务订单</span>
      </div>
      <div class="purchaser">
        购买方：{{userName}}
      </div>
      <div class="item">
        <el-table
            :data="tableData"
            style="width: 100%"
            class="order-table"
            :header-cell-style="{
              backgroundColor:'#E8EFF9',
              color:'#3A5372',
              fontSize:'18px',
              height:'60px'
              }"
        >
          <el-table-column prop="date" label="服务提供商：北京正元安服科技有限公司" >
            <template slot-scope="scope">
              <div style="display: flex;align-items: center">
                <div>
                  <img style="width: 146px;height: 99px;margin-right: 60px" src="@/assets/images/serveOrder.png" alt="">
                </div>
                <div style="color: #3A5372;font-size: 16px;">
                  <p style="">符合电子签名法,合规合法电子签章签署服务</p>
                  <p>(服务时效1年有效，到期后需重新购买)</p>
                </div>

              </div>


            </template>
          </el-table-column>
          <el-table-column prop="amonut" label="单价" width="260" header-align="center" align="center">
            <template slot-scope="scope">
              <span style="color:#3A5372;font-size: 16px;">{{scope.row.amonut}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="数量（单位/年）"  width="260" header-align="center" align="center">
            <template slot-scope="scope">
              <span style="color:#3A5372;font-size: 16px;">{{scope.row.num}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="total" label="小计"  width="260" header-align="center" align="center">
            <template slot-scope="scope">
              <span style="color: #0072FF;font-size: 16px;">{{scope.row.amonut}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="invoiceInfo">
          <div style="height: 86px;line-height: 86px;">
<!--            <div style="font-size: 16px;color: #3A5372;margin-bottom: 10px">开票信息</div>-->
<!--            <div style="font-size: 14px;color: #FF0101">-->
<!--              请将您的开票信息发送至 381972290@qq.com,联系电话：18608006961-->
<!--            </div>-->
            <el-alert
                title="申请发票：请将您的开票信息发送至 895777194@qq.com 邮箱，技术服务热线：17780520853 "
                type="warning"
                :closable="false"
                style="display: inline"
                show-icon>
            </el-alert>
          </div>
          <div style="width: 260px;height: 86px;line-height: 86px;text-align: center">
            <span style="color: #3A5372;font-size: 16px">合计</span><span style="color: #0072FF;font-size: 16px;padding-right: 40px;padding-left: 20px">{{totalMoney}}</span>
          </div>
        </div>
        <div class="notes">
          <div class="notes-box">
            <span class="txt" style="">备注:</span>
            <el-input class="input" v-model="remarks"></el-input>
          </div>
        </div>
      </div>
      <div class="pay_type" v-if="status=='notPay'">
        <div class="pay_type_title">
          <span>选择支付方式</span>
        </div>
        <div class="pay_item">
          <div class="alipay-img" @click="getZfbPayLinkApi">
            <img src="@/assets/images/alipay.png" alt="">
          </div>
          <div class="wechat-img" @click="getWxPayLinkApi">
            <img src="@/assets/images/wechat.png" alt="">
          </div>
          <div>
<!--            <el-button class="submitBtn" type="primary" @click="getZfbPayLinkApi">立即支付</el-button>-->
          </div>

        </div>
      </div>
      <div class="pay_type" v-if="status=='pay'">
        <div class="pay_type_title">
          <span>支付详情</span>
        </div>
        <div class="pay_item">
         <div style="font-size: 16px;color: #3A5372;margin-bottom: 20px;margin-left: 32px">支付时间: {{payTime}}</div>
         <div style="font-size: 16px;padding-bottom: 150px"> <span style="color: #3A5372;margin-left: 32px">支付状态:</span>  <span style="color: #02E074">已支付</span> </div>

        </div>
      </div>

    </div>
    <!-- 支付弹窗 -->
    <el-dialog
        title="支付"
        :visible.sync="payModal"
        width="30%"
        :before-close="closePayDialog"
        :modal-append-to-body="false"
        class="wxPayDialog"

    >
      <div class="wxPayImgContent">
        <div>
          使用
          <span  class="pay-for-method-1">微信</span>
          扫一扫二维码进行支付
        </div>
        <img class="wxPayImgUrl" :src="wxPayImgUrl" alt="">
        <div>注：若二维码过期失效，请刷新页面重新进入支付！</div>
      </div>
      <span slot="footer" class="dialog-footer" style="text-align: right">
            <el-button @click="closePayDialog" size="small">返回</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import { getOrderInfo,getZfbPayLink,getWxPayLink ,getVXPayResult} from "@/api/electronSealOrder";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      tableData: [],
      orderId:'',//订单id
      payPageUrl:'',//支付宝支付连接
      totalMoney:0,
      remarks:'',
      status:'',//订单状态
      userName:'',//购买方
      payTime:'',//支付时间
      payModal:false,
      timer:null,
      wxPayImgUrl:''
    };
  },
  computed: {},
  watch: {},
  methods: {
    getOrderInfoApi(){
      getOrderInfo({
        id: this.orderId,
      }).then((res) => {
        if(res.code!==200){
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        }else{
          this.tableData=[];
          this.status=res.data.status;
          this.userName=res.data.userName;
          this.payTime=res.data.payTime;
          let obj=res.data;
          obj.num=1;
          obj.total=obj.amonut;
          this.totalMoney=obj.amonut;

          this.tableData.push(obj)
        }

      })
    },
    getZfbPayLinkApi(){
      getZfbPayLink({
        id: this.orderId,
      }).then((res) => {

        if(res.code!==200){
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        }else{
          // this.payPageUrl=res.data.payPage;
          window.location.href=res.data.payPage;
        }
      })
    },

    getWxPayLinkApi(){
      getWxPayLink({
        id: this.orderId,
      }).then((res) => {

        if(res.code!==200){
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        }else{
          if(!res.data.qrCode){
            this.$message({
              showClose: true,
              message: "请刷新页面重新进入支付！",
              type: "warning",
            });
          }else{
            this.wxPayImgUrl="data:image/png;base64,"+res.data.qrCode;
            this.payModal=true;
            this.timer = setInterval(() => {
              this.handleQueryWxPayStatus(res.data.orderId, res.data.returnUrl);
            }, 1000);
          }


        }
      })
    },
    closePayDialog(){
      this.payModal=false;
      clearInterval(this.timer);    // 清除定时器
    },
    handleQueryWxPayStatus(orderId,returnUrl){
      getVXPayResult({
        orderId: orderId,
      }).then((res) => {
        console.log(res)
        if(res.code!==200){
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        }else{
          if(res.data.status=='1'){
            this.$message({
              type: 'success',
              message: '支付成功！'
            });
            this.closePayDialog();
            window.location.href=returnUrl;
          }

        }
      })
    }
  },
  created() {
    this.orderId = this.$route.query.id;
    this.getOrderInfoApi();
  },
  mounted() {

  },
  beforeDestroy(){
    clearInterval(this.timer);
  }
}
</script>
<style scoped lang="scss">
.main-container{
  background: #F3F3F7;
  .box-card{
    .area-title{
      display: flex;
      align-items: center;
      font-size: 24px;
      font-weight: 500;
      color: #fff;
      padding-left: 33px;
      background-color: #09284E;
      height: 80px;
    }
    .purchaser{
      height: 88px;
      line-height: 88px;
      font-size: 18px;
      color: #3A5372;
      font-weight: bold;
      padding-left: 53px;
    }

    .item{
      padding: 0 33px;
      .order-table{
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        /deep/ .el-table__header-wrapper{
          background-color: #E8EFF9;
        }
      }
      .invoiceInfo{
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E8E8E8;
        background-color: #fff;
        padding-left: 20px;
      }
      .notes{
        padding: 14px 0;
        background-color: #fff;
        .notes-box{
          border: 1px solid #EBEBEB;
          height: 50px;
          line-height: 50px;
          border-radius: 20px;
          margin: 0 26px;
          display: flex;
          align-items: center;

          .txt{
            font-size: 14px;
            color: #B8B8B8;
            margin-left: 21px;
            min-width: 45px;
            flex-shrink: 0;
          }
          /deep/ .el-input .el-input__inner{
            border: none;
          }
          .input{
            width: 80%;

          }
        }
      }
    }
    .pay_type{
      padding: 0 33px;
      margin-bottom: 40px;
      .pay_type_title{
        border-radius: 20px 20px 0px 0px;
        background: #E8EFF9;
        color: #3A5372;
        font-size: 18px;
        height: 60px;
        line-height: 60px;
        padding-left: 20px;
        margin-top: 20px;
      }
      .pay_item{
        background-color: #fff;
        padding-top: 37px;
        border-radius: 0px 0px 20px 20px;
        .alipay-img{
          width: 145px;
          height: 67px;
          border: 1px solid #E8EFF9;
          padding: 10px 15px;
          border-radius: 10px;
          margin-bottom: 120px;
          margin-left: 32px;
          display: inline-block;
          cursor: pointer;
          img {
            vertical-align: baseline;
            width: 100%;
            height: 100%;
          }
        }
        .wechat-img{
          width: 145px;
          height: 67px;
          border: 1px solid #E8EFF9;
          padding: 10px 15px;
          border-radius: 10px;
          margin-bottom: 120px;
          margin-left: 32px;
          display: inline-block;
          cursor: pointer;

          img {
            vertical-align: baseline;
            width: 100%;
            height: 100%;
          }
        }

        .submitBtn{
          width: 118px;
          height: 48px;
          margin-left: 32px;
          margin-bottom: 40px;
          border-radius: 10px;
        }
      }
    }

  }


}
.wxPayDialog{
  .wxPayImgContent{
    text-align: center;
    .wxPayImgUrl{
      width: 300px;
      height: 300px;
    }
  }
  /deep/ .el-dialog__footer{
    text-align: right;

  }

}


</style>
